/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'refresh': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(7 8)" _stroke="#00272E"><polyline pid="0" points="3.70195238 10.62415 3.70195238 14.44915 0.463857143 14.44915"/><path pid="1" d="M3.702 14.45C.745 11.6.372 6.842 2.846 3.523S9.81-.558 13.154 1.773c3.344 2.33 4.42 6.969 2.469 10.652-1.951 3.683-6.272 5.172-9.922 3.418"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/refresh.js